import { ColorAnalyzer } from './color-analyzer';

/**
 * maybe url、File、Base64、HTMLImageElement
 * @param img
 * @returns
 */
const genExpireIconColors = async (img: any) => {
  const analyzer = new ColorAnalyzer();

  // expire-bg-color expire-text-color
  const expireBgAlpha = 1;
  const expireTextColor = 'rgb(255, 255, 255)';

  const method = detectImageType(img);
  if (!method) {
    return { expireBgColor: `rgba(0, 0, 0, ${expireBgAlpha})`, expireTextColor: expireTextColor };
  }

  const hex = (await (analyzer as any)[method](img, { format: 'hex' })) as string;
  const { r, g, b } = hexToRgb(hex) ?? { r: 0, g: 0, b: 0 };

  const isNearWhite = r > 240 && g > 240 && b > 240;
  const expireBgColor = isNearWhite
    ? `rgba(200, 200, 200, ${expireBgAlpha})`
    : `rgba(${r}, ${g}, ${b}, ${expireBgAlpha})`;

  return { expireBgColor, expireTextColor };
};

function detectImageType(value: any): 'fromImage' | 'fromFile' | 'fromBase64' | 'fromUrl' | null {
  if (typeof window !== 'undefined' && value instanceof (window as any).HTMLImageElement) {
    return 'fromImage';
  }
  if (
    typeof File !== 'undefined' &&
    value instanceof File &&
    value.type?.startsWith?.('image/')
  ) {
    return 'fromFile';
  }
  if (typeof value === 'string' && value.startsWith('data:image/')) {
    return 'fromBase64';
  }
  if (typeof value === 'string' && value) {
    try {
      const url = new URL(value);
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];
      const pathname = url.pathname.toLowerCase();
      if (imageExtensions.some((ext) => pathname.endsWith(ext))) return 'fromUrl';
    } catch (_) {
      // not a valid URL
      console.warn('Not a valid URL ' + value);
    }
  }
  return null;
}

function hexToRgb(hex: string): { r: number; g: number; b: number } | null {
  if (!hex) return null;
  const value = hex.replace('#', '').trim();
  if (value.length === 3) {
    const r = parseInt(value[0] + value[0], 16);
    const g = parseInt(value[1] + value[1], 16);
    const b = parseInt(value[2] + value[2], 16);
    return { r, g, b };
  }
  if (value.length === 6) {
    const r = parseInt(value.slice(0, 2), 16);
    const g = parseInt(value.slice(2, 4), 16);
    const b = parseInt(value.slice(4, 6), 16);
    return { r, g, b };
  }
  return null;
}

export { genExpireIconColors };
